import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  Image,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';

const CommunityGallery = ({ 
  product,
  enableLazyLoading = true,
}) => {
  const toast = useToast();

  const headingColor = useColorModeValue("white", "white");

  // Handle image error
  const handleImageError = () => {
    toast({
      title: "Image failed to load",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  };

  // Dynamic button click handler
  const handleButtonClick = () => {
    if (product?.communityHero?.buttonUrl && product.communityHero.buttonUrl !== "#") {
      window.open(product.communityHero.buttonUrl, "_blank");
    }
  };

  if (!product) return null;

  return (
    <Box>
      {/* Hero Section from NavigationItems - Only show if communityHero exists */}
      {product.communityHero && (
        <Box
          bg={product.communityHero.gradient}
          py={16}
          px={6}
          textAlign="center"
          position="relative"
          overflow="hidden"
          borderRadius="lg"
        >
          <Container maxW="4xl">
            <Heading
              as="h1"
              size="2xl"
              color={headingColor}
              fontWeight="bold"
              mb={6}
            >
              {product.communityHero.title}
            </Heading>

            <Text
              fontSize={{ base: "md", md: "lg" }}
              color="gray.100"
              lineHeight="tall"
              mb={8}
              maxW="3xl"
              mx="auto"
            >
              {product.communityHero.description}
            </Text>

            <Button
              size="lg"
              bg="white"
              color="#000B8C"
              _hover={{ bg: "gray.100" }}
              borderRadius="full"
              px={8}
              onClick={handleButtonClick}
            >
              {product.communityHero.buttonText}
            </Button>
          </Container>
        </Box>
      )}

      {/* Gallery Images from NavigationItems */}
      {product.galleryImages && product.galleryImages.length > 0 && (
        <Box py={12} px={4}>
          <Container maxW="7xl">
            <Heading 
              as="h2" 
              size="xl" 
              textAlign="center" 
              mb={8}
              color="gray.700"
            >
              Gallery
            </Heading>
            
            {/* Responsive Grid Gallery Layout */}
            <Box
              display="grid"
              gridTemplateColumns={{
                base: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(4, 1fr)"
              }}
              gap={4}
              alignItems="start"
            >
              {product.galleryImages
                .slice() 
                .reverse() 
                .slice(0, 8)
                .map((image, index) => (
                <Box
                  key={image.id || index}
                  position="relative"
                  overflow="hidden"
                  borderRadius="lg"
                  boxShadow="md"
                  transition="all 0.3s ease"
                  _hover={{
                    transform: "translateY(-2px)",
                    boxShadow: "lg"
                  }}
                  cursor="pointer"
                  bg="white"
                  height="250px"
                  width="100%"
                >
                  <Image
                    src={image.src}
                    alt={image.alt}
                    w="100%"
                    h="100%"
                    borderRadius="lg"
                    onError={handleImageError}
                    loading={enableLazyLoading ? "lazy" : "eager"}
                    objectFit="cover"
                  />
                </Box>
              ))}
            </Box>
          </Container>
        </Box>
      )}
    </Box>
  );
};

export default CommunityGallery;
